<router-outlet [@if]="loadedProfile"></router-outlet>
